import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useHospiceConvertToPending } from "../../store/useHospiceConvertToPending";

import Pharmacy from "./Pharmacy/Pharmacy.vue";
import PatientDME from "./PatientDME/PatientDME.vue";
import PatientSupply from "./PatientSupply/PatientSupply.vue";

export default defineComponent({
    components: {
        Pharmacy,
        PatientDME,
        PatientSupply
    },
    computed: {
        ...mapState(useHospiceConvertToPending, ["patientDetails"])
    }
});
